import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';


import { auth, logout, getData, updateDataByUserId } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import { IMAGES } from "../../constants/index"
import RHEMAS from "../../constants/rhema";

import './RhemaPage.css';


function RhemaPage(){
    let navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [data,setData] = useState(0)
    const [opacity, setOpacity] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false); 
    const [dayIndex,setDayIndex] = useState(0)
    const [rhema, setRhema] = useState(null);
    const [isSavedRhema, setIsSavedRhema] = useState(false);


    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        if(user){
            getUserData();
        }
    }, [user]);
    
    useEffect(() => {
        if(data){
            checkRhema();
        }
    }, [data]);

    useEffect(() => {
        if(rhema!=null){
            setTimeout(() => {
                setOpacity(1);
            }, 500); // 0.5초 후 페이드 인
        }
    }, [rhema]);

    // useEffect(()=>{
    //     if(index) {
    //         getRhema();
    //     }
    // },[index])
    

    const getUserData = async () => {
        const data = await getData(user.uid)
        setData(data[0])
        setDayIndex(Object.keys(data[0]?.checkList || {}).length-1);
    }
    const checkRhema = async () => {
        // getRhema()
        if(data.rhema&&data.rhema[dayIndex]) {
            setRhema(data.rhema[dayIndex])
            setIsSavedRhema(true)
        }
        else {
            getRhema()
            setIsSavedRhema(false)
        }
    }

    const getRhema = async () => {
        const rhemaIndex = await getRandomInt(0,RHEMAS?.length-1)
        setRhema(RHEMAS[rhemaIndex])
    }
    const myFaithPage = async () => {
        // setIndex(prevIndex => prevIndex + 1); // ✅ 상태 업데이트 올바르게 적용
        setOpacity(0); // 🔥 페이드 아웃 시작
        setTimeout( async() => {
            if(!isSavedRhema){
                // 🔹 현재 Firestore에서 가져온 data.rhema가 배열인지 확인
                const existingRhema = Array.isArray(data?.rhema) ? data.rhema : [];
        
                // 🔹 새로운 데이터 추가
                const dataTemp = {
                    rhema: [...existingRhema, rhema] // 🔥 기존 데이터 유지 + 새로운 데이터 추가
                };
        
                // 🔹 상태 업데이트 & Firestore 업데이트  
                await updateDataByUserId(user.uid, dataTemp);
            }
            handleNavigation('/myFaith')
        }, 2000);
    }

    const handleNavigation = (address) => {
        navigate(address);
    }
    const handlelogout = async() => {
        const result = await logout()
        navigate('/login');
    }
    const getRandomInt = async (min, max) => {
        return await Math.floor(Math.random() * (max - min + 1)) + min;
    };
      
    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="rhemaWrap" style={{ opacity, transition: "opacity 1s ease-in-out" }} onClick={myFaithPage}>
                <div className="contentsTitle">
                    {/* <span>믿음의 여정</span> */}
                </div>
                <div className="contents">
                    {rhema&&
                    <>
                    <pre className="rhemaText">{rhema?.rhema}</pre>
                    <p className="addressText">[{rhema?.address}]</p>
                    {/* <span style={{color:'#fff'}}>{index}</span> */}
                    </>
                    }
                </div>    
                <div className="contentsButton">
                    {/* <span onClick={myFaithPage}>믿음의 여정 살펴보기</span> */}
                </div>       
            </div>
        </div>
    );
  }
  export default RhemaPage;